var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDisplayed)?_c('div',{staticClass:"pagination-item",class:_vm.className,on:{"click":function($event){return _vm.updatePage(_vm.page)}}},[_vm._v(" "+_vm._s(_vm.page)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }